import Share from "./Share.component";

export default Share;
